import {contentToggleLineColour} from "../../style/styleConsts";
import styled from "styled-components";

export const Line = styled.div`
    position: absolute;
    display: block;
    height: 50%;
    width: 100%;
    top: 0;
    border-bottom: 1px solid ${contentToggleLineColour};
    z-index: -1;
`;